import axios from "axios";

const axiosSuperAdmin = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin`,
  method: "get",
});

const axiosCreateCompany = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/companies`,
  method: "post",
});

const axiosGetCompanies = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/companies`,
  method: "get",
});

// Add interceptor to handle token
axiosGetCompanies.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosGetCompanyDetails = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/companies`,
  method: "get",
});

const axiosUpdateCompany = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/companies`,
  method: "put",
});

const axiosDeleteCompany = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/companies`,
  method: "delete",
});

const axiosGetTemplates = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/templates`,
  method: "get",
});

// Add interceptor to handle token
axiosGetTemplates.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Questions management
const axiosGetQuestions = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/questions`,
  method: "get",
});

// Add interceptor to handle token
axiosGetQuestions.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosCreateQuestion = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/questions`,
  method: "post",
});

const axiosUpdateQuestion = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/questions`,
  method: "put",
});

const axiosDeleteQuestion = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/questions`,
  method: "delete",
});

// Categories management
const axiosGetCategories = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/categories`,
  method: "get",
});

// Add interceptor to handle token
axiosGetCategories.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosCreateCategory = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/categories`,
  method: "post",
});

const axiosUpdateCategory = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/categories`,
  method: "put",
});

const axiosDeleteCategory = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/categories`,
  method: "delete",
});

// Skills management
const axiosGetSkills = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/skills`,
  method: "get",
});

// Add interceptor to handle token
axiosGetSkills.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosCreateSkill = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/skills`,
  method: "post",
});

const axiosUpdateSkill = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/skills`,
  method: "put",
});

const axiosDeleteSkill = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/skills`,
  method: "delete",
});

// Languages management
const axiosGetLanguages = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/languages`,
  method: "get",
});

// Add interceptor to handle token
axiosGetLanguages.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosCreateLanguage = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/languages`,
  method: "post",
});

// Master templates management
const axiosGetMasterTemplates = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/master-templates`,
  method: "get",
});

// Add interceptor to handle token
axiosGetMasterTemplates.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosCreateMasterTemplate = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/master-templates`,
  method: "post",
});

// Add interceptor to handle token
axiosCreateMasterTemplate.interceptors.request.use((config) => {
  const token = config.token || localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const axiosUpdateMasterTemplate = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/master-templates`,
  method: "put",
});

const axiosDeleteMasterTemplate = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/master-templates`,
  method: "delete",
});

// System stats
const axiosGetSystemStats = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/stats`,
  method: "get",
});

// Company Template Management
const axiosGetCompanyTemplates = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/company-templates`,
  method: "get",
});

const axiosGetCompanyTemplateDetails = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/company-templates`,
  method: "get",
});

const axiosUpdateCompanyTemplate = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/company-templates`,
  method: "put",
});

const axiosDeleteCompanyTemplate = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/company-templates`,
  method: "delete",
});

const axiosCreateCompanyTemplate = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/company-templates`,
  method: "post",
});

// Add interceptors to company template management axios instances
[
  axiosGetCompanyTemplates,
  axiosGetCompanyTemplateDetails,
  axiosUpdateCompanyTemplate,
  axiosDeleteCompanyTemplate,
  axiosCreateCompanyTemplate,
].forEach((axiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    const token = config.token || localStorage.getItem("token");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
});

export {
  axiosSuperAdmin,
  axiosCreateCompany,
  axiosGetCompanies,
  axiosGetCompanyDetails,
  axiosUpdateCompany,
  axiosDeleteCompany,
  axiosGetTemplates,
  // Questions
  axiosGetQuestions,
  axiosCreateQuestion,
  axiosUpdateQuestion,
  axiosDeleteQuestion,
  // Categories
  axiosGetCategories,
  axiosCreateCategory,
  axiosUpdateCategory,
  axiosDeleteCategory,
  // Skills
  axiosGetSkills,
  axiosCreateSkill,
  axiosUpdateSkill,
  axiosDeleteSkill,
  // Languages
  axiosGetLanguages,
  axiosCreateLanguage,
  // Master Templates
  axiosGetMasterTemplates,
  axiosCreateMasterTemplate,
  axiosUpdateMasterTemplate,
  axiosDeleteMasterTemplate,
  // System Stats
  axiosGetSystemStats,
  // Company Template Management
  axiosGetCompanyTemplates,
  axiosGetCompanyTemplateDetails,
  axiosCreateCompanyTemplate,
  axiosUpdateCompanyTemplate,
  axiosDeleteCompanyTemplate,
};
